<div class="d-flex align-items-center h-100">
  <form [formGroup]="form" (ngSubmit)="login()" method="post" class="custom-form m-auto">
    <h1 class="h3 mb-3 fw-normal">Log in</h1>
    <div class="form-floating">
      <input type="text" formControlName="username" placeholder="Username" required="required" id="username"
        class="form-control">
      <label for="email">Username</label>
    </div>

    <div class="form-floating">
      <input type="password" formControlName="password" placeholder="Password" required="required" id="password"
        class="form-control">
      <label for="password">Password</label>
    </div>

    <button type="submit" class="btn btn-primary w-100 mt-3">Log in</button>
  </form>
</div>
